import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from 'react';
import { usePopper } from 'react-popper';
export var useTooltip = function useTooltip(id) {
  var placement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'bottom-start';
  var onChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var isMobile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      referenceNode = _useState4[0],
      setReferenceNode = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      popperNode = _useState6[0],
      setPopperNode = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      arrowNode = _useState8[0],
      setArrowNode = _useState8[1];

  var _usePopper = usePopper(referenceNode, popperNode, {
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 10]
      }
    }, {
      name: 'arrow',
      options: {
        element: arrowNode
      }
    }, {
      name: 'preventOverflow',
      options: {
        rootBoundary: 'viewport',
        altAxis: true
      }
    }],
    placement: placement
  }),
      styles = _usePopper.styles,
      attributes = _usePopper.attributes,
      update = _usePopper.update,
      state = _usePopper.state;

  var showTooltip = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event === null || event === void 0 ? void 0 : event.persist();
              event === null || event === void 0 ? void 0 : event.stopPropagation();
              event === null || event === void 0 ? void 0 : event.preventDefault();

              if (!(update instanceof Function)) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return update();

            case 6:
              setIsOpen(true);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function showTooltip(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var hideTooltip = function hideTooltip(event) {
    event === null || event === void 0 ? void 0 : event.persist();
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    event === null || event === void 0 ? void 0 : event.preventDefault();
    setIsOpen(false);
  };

  var onBlurCallback = function onBlurCallback(_ref2) {
    var relatedTarget = _ref2.relatedTarget,
        nativeEvent = _ref2.nativeEvent;
    if (isMobile) return;
    nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.stopImmediatePropagation();
    var isValidHTMLNode = relatedTarget instanceof Element;

    if (!isValidHTMLNode || !(referenceNode !== null && referenceNode !== void 0 && referenceNode.contains(relatedTarget)) && !(popperNode !== null && popperNode !== void 0 && popperNode.contains(relatedTarget))) {
      hideTooltip();
    }
  };

  useEffect(function () {
    var handleScroll = function handleScroll() {
      hideTooltip();
    };

    document.addEventListener('scroll', handleScroll, true);
    return function () {
      document.removeEventListener('scroll', handleScroll, true);
    };
  }, [hideTooltip]);
  useEffect(function () {
    onChange && onChange(isOpen);
  }, [isOpen, onChange]);
  return {
    isOpen: isOpen,
    showTooltip: showTooltip,
    hideTooltip: hideTooltip,
    placement: state === null || state === void 0 ? void 0 : state.placement,
    triggerProps: {
      id: id,
      ref: setReferenceNode,
      onMouseEnter: showTooltip,
      onClick: showTooltip,
      onFocus: showTooltip,
      onMouseLeave: onBlurCallback,
      onBlur: onBlurCallback
    },
    tooltipProps: _objectSpread(_objectSpread({
      'aria-labelledby': id,
      ref: setPopperNode,
      style: styles.popper
    }, attributes.popper), {}, {
      isOpen: isOpen,
      zIndex: 'tooltip',
      onMouseLeave: onBlurCallback,
      onBlur: onBlurCallback
    }),
    arrowProps: {
      ref: setArrowNode,
      style: styles.arrow,
      className: 'arrow'
    }
  };
};